import { Text, Tooltip } from '@elkaso-app/web-design';
import React from 'react';

export interface EntityNameCellProps {
  entityName: string;
}

export const EntityNameCell: React.FC<EntityNameCellProps> = ({ entityName }) => (
  <div style={{ height: '80px', display: 'flex', alignItems: 'center', padding: '8px 0', maxWidth: '100%' }}>
    <Tooltip label={entityName} isDisabled={entityName?.length <= 30}>
      <Text
        fontWeight='semibold'
        fontSize='md'
        color='gray.800'
        lineHeight='1.2'
        maxW='100%'
        wordBreak='break-word'
        whiteSpace='normal'
        noOfLines={2}>
        {entityName || 'N/A'}
      </Text>
    </Tooltip>
  </div>
);
